import React, {useEffect, useState} from 'react';
import {Col, Row, Tabs} from 'antd';
import {Tabs as MobileTabs} from 'antd-mobile';
import {useRequest} from 'ahooks';
import PcComponentWrapper from '@/components/PcComponentWrapper';
import CouponItem, {TCouponItem,} from '@/page-components/detail/Intro/Coupon/couponItem';
import MobileComponentWrapper from '@/components/MobileComponentWrapper';
import {apiShequGetCouponList} from '@/services/coupon';
import CouponChange from '@/page-components/detail/Intro/Coupon/couponChange';
import {TExamKind} from '@/types';
import styles from '../styles.module.less';

const { TabPane } = Tabs;

type TCoupon = {
  type: TExamKind;
  onChange: (coupons: TCouponItem[]) => void;
  isOrganizationAdmin?: boolean;
  isMySelfSignup?: boolean;
  totalPrice?: any;
};

const Coupon: React.FC<TCoupon> = ({
  isMySelfSignup,
  isOrganizationAdmin,
  type,
  onChange,
  totalPrice,
}) => {
  const [activeKey, setActiveKey] = useState('1');
  const [coupons, setCoupons] = useState<TCouponItem[]>([]);
  const [selectCoupon, setSelectCoupon] = useState<TCouponItem[]>([]);
  const [suitableCouponKey, setSuitableCouponKey] = useState(0);
  const [suitableCouponVal, setSuitableCouponVal] = useState(0);
  const [couponTooltip, setCouponTooltip] = useState(false);
  const { loading, run: getCoupon } = useRequest(
    () => {
      return apiShequGetCouponList(type, totalPrice);
    },
    {
      manual: true,
      onSuccess: (res) => {
        console.log('Coupon组件获取优惠券项目');
        console.log(res);
        if (res.code === 200) {
          if (Array.isArray(res.data.list)) {
            setCoupons(res.data.list);
          }
          if (res.data.suitableCoupon) {
            setSuitableCouponKey(res.data.suitableCoupon.coupon_log_id);
            setSuitableCouponVal(res.data.suitableCoupon.coupon_value);
          }
        }
      },
    },
  );
  // 关闭自动选中tips
  const closecCouponTooltip = () => {
    setCouponTooltip(false);
  };

  // 自动滚动优惠券列表
  const scrollCouponBox = () => {
    setTimeout(() => {
      if (suitableCouponKey > 0) {
        setCouponTooltip(true);
        const parent = document.querySelector('.ant-tabs-top');
        const child = document.getElementById(
          `couponItem_${suitableCouponKey}`,
        );
        const couponBox_h = (parent as HTMLDivElement)?.offsetHeight - 100;
        const coupon_y = child?.offsetTop || 0;
        console.log('scrollCouponBox', coupon_y, couponBox_h);
        if (coupon_y > couponBox_h) {
          parent?.scrollTo({ top: coupon_y, behavior: 'smooth' });
        }
      }
    }, 800);
  };

  // 自动选中tips
  const AutoCouponTooltip = ({ couponLogId = 0 }) => {
    if (couponTooltip && suitableCouponKey === couponLogId) {
      return (
        <div
          onClick={() => {
            closecCouponTooltip();
          }}
          className={styles.coupons_tooltip}
        >
          <div className="flex-1">
            <span className={styles.text}>已自动选择最适合的优惠券</span>
            <img
              className={styles.close_coupon}
              height="12"
              src="/img/close_coupon.png"
            />
          </div>
        </div>
      );
    }
    return null;
  };

  useEffect(() => {
    if (
      (isOrganizationAdmin !== undefined && !isOrganizationAdmin) ||
      (isMySelfSignup && !loading)
    ) {
      getCoupon();
      scrollCouponBox();
    }
  }, [isOrganizationAdmin, suitableCouponKey, suitableCouponVal]);

  return (
    <>
      <PcComponentWrapper>
        <Tabs
          tabBarStyle={{ paddingLeft: 15 }}
          activeKey={activeKey}
          className={styles.coupons}
          onChange={(res) => {
            setActiveKey(res);
          }}
        >
          <TabPane tab="可用优惠券" key="1">
            {loading ? (
              <p>正在加载中</p>
            ) : (
              <>
                {!coupons || coupons?.length === 0 ? (
                  <p className={styles.empty_text}>暂时没有可用优惠券哦</p>
                ) : (
                  <Row className={styles.coupon_wrapper} wrap gutter={12}>
                    {coupons?.map((item) => {
                      return (
                        <Col
                          span={24}
                          key={item.coupon_log_id}
                          id={`couponItem_${item.coupon_log_id}`}
                        >
                          <AutoCouponTooltip couponLogId={item.coupon_log_id} />
                          <CouponItem
                            activeId={
                              selectCoupon.length === 0
                                ? undefined
                                : selectCoupon[0].coupon_log_id
                            }
                            item={item}
                            onChange={() => {
                              const findItemIdx = selectCoupon.findIndex(
                                (selectItem) =>
                                  selectItem.coupon_id === item.coupon_id,
                              );
                              if (findItemIdx > -1) {
                                setSelectCoupon((prevState) => {
                                  setCouponTooltip(false);
                                  prevState.splice(findItemIdx, 1);
                                  onChange([...prevState]);
                                  return [...prevState];
                                });
                              } else {
                                setSelectCoupon(() => {
                                  setCouponTooltip(false);
                                  onChange([item]);
                                  return [...[item]];
                                });
                              }
                            }}
                            suitableCouponId={
                              suitableCouponKey === item.coupon_log_id
                                ? suitableCouponKey
                                : 0
                            }
                          />
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </>
            )}
          </TabPane>
          <TabPane tab="兑换优惠券" key="2" className={styles.coupon_wrapper}>
            <CouponChange
              isMySelfSignup={isMySelfSignup}
              isOrganizationAdmin={isOrganizationAdmin}
              onChangeSuccess={(data) => {
                // 直接跳转至第一个tab
                setActiveKey('1');
                // 将新兑换的优惠卷加入列表的第一个
                setCoupons((prevState) => {
                  prevState.unshift(data);
                  return [...prevState];
                });
                // 自动选中
                setSelectCoupon((prevState) => {
                  prevState.push(data);
                  onChange([data]);
                  return [...prevState];
                });
              }}
            />
            <div className={styles.conversion_row}>
              <p className={styles.gap}>提示：</p>
              <p className={styles.gap}>
                1.
                兑换码获取：参与社区活动有机会获得优惠券兑换码，兑换码是16位；
              </p>
              <p className={styles.gap}>
                2.
                兑换码使用：在上方输入框输入兑换码即可兑换相应优惠券，一个兑换码只能兑换一张优惠券，不可重复使用；
              </p>
            </div>
          </TabPane>
        </Tabs>
      </PcComponentWrapper>
      <MobileComponentWrapper>
        <MobileTabs
          defaultActiveKey="1"
          onChange={() => {}}
          className={styles.coupons}
        >
          <MobileTabs.Tab title="可用优惠券" key="1">
            <Row
              className={styles.coupon_wrapper}
              style={{ padding: 0 }}
              wrap
              gutter={12}
            >
              {coupons?.map((item) => {
                return (
                  <Col
                    span={24}
                    key={item.coupon_log_id}
                    id={`couponItem_${item.coupon_log_id}`}
                  >
                    <AutoCouponTooltip couponLogId={item.coupon_log_id} />
                    <CouponItem
                      item={item}
                      onChange={() => {
                        const findIdx = selectCoupon.findIndex(
                          (selectItem) =>
                            selectItem.coupon_log_id === item.coupon_log_id,
                        );
                        if (findIdx > -1) {
                          setSelectCoupon((prev) => {
                            prev.splice(findIdx, 1);
                            onChange(prev);
                            return [...prev];
                          });
                        } else {
                          setSelectCoupon((prev) => {
                            prev.push(item);
                            onChange(prev);
                            return [...prev];
                          });
                        }
                      }}
                      suitableCouponId={
                        suitableCouponKey === item.coupon_log_id
                          ? suitableCouponKey
                          : 0
                      }
                    />
                  </Col>
                );
              })}
            </Row>
          </MobileTabs.Tab>
          <MobileTabs.Tab title="兑换优惠券" key="2">
            <div className={styles.coupon_wrapper}>
              <CouponChange
                onChangeSuccess={(data) => {
                  setSelectCoupon((prevState) => {
                    prevState.push(data);
                    return [...prevState];
                  });
                }}
              />
              <div className={styles.conversion_row}>
                <p className={styles.gap}>提示：</p>
                <p className={styles.gap}>
                  1.
                  兑换码获取：参与社区活动有机会获得优惠券兑换码，兑换码是16位；
                </p>
                <p className={styles.gap}>
                  2.
                  兑换码使用：在上方输入框输入兑换码即可兑换相应优惠券，一个兑换码只能兑换一张优惠券，不可重复使用；
                </p>
              </div>
            </div>
          </MobileTabs.Tab>
        </MobileTabs>
      </MobileComponentWrapper>
    </>
  );
};
export default Coupon;
